module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page24",
      "title": "24"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _vm._v("2")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-6",
      "title": "2 The World that We Shape and the World that Shapes Us: The Transformative Power of Cruciform Worship"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _vm._v("The World that We Shape and the World that Shapes Us")]), _vm._v(" "), _c('h3', {
    staticClass: "chapter-subtitle---IVP sigil_not_in_toc",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _vm._v("The Transformative Power of Cruciform Worship")]), _vm._v(" "), _c('p', {
    staticClass: "dingbat"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/cross_chap.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v("n chapter one, I argued that through our stories, we either transform or deform ourselves, the communities in which we live, and indeed the entire world. There I contrasted the fallen world that operates according to the myth of redemptive violence with the true story of the love of God in the person of Jesus Christ. The world invests in violence, coercion, and manipulation as the means of accomplishing its will in spite of or instead of the other. The kingdom of God as preached in the gospel presents us with another way forward, the way of God’s cruciform love. The cruciform way of God in Christ is a manner of living in which every person lives and exists for the sake of the other.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_4"
    }
  }, [_vm._v("Cruciform Worship: Worship that Forms us In the Way of the Cross")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The adjective "), _c('i', {
    staticClass: "i"
  }, [_vm._v("cruciform")]), _vm._v(" is a theological word used to refer to the worldview and way of life that focuses on the others-centered, self-giving love of God in the sacrificial life and death of Jesus Christ. In this book I am adopting and expanding upon the cruciform theology of Michael Gorman by applying it to the realm of worship."), _c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/notes#_idTextAnchor887",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page25",
      "title": "25"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _vm._v("What does this theme of cruciformity contribute to a theology of worship? Let me explain. When God calls us to lead and live in the church, he calls us to lead and live not as lords but as servants. He calls us to model our motivations, actions, desires, and goals after the cruciform love of Jesus Christ. To be cruciform means to be conformed to the others-centered, self-giving way of the cross, the way demonstrated by Jesus himself in his humble life and death for sinners. It means seeking not to control, manipulate, intimidate, or coerce people on the basis of one’s own skill, position, or prestige. Instead we are called to relinquish the desire to rule as lords, to lay down the false security and pursuit of power, to forsake the ways of the world, and therein to discover what it means to be truly and abundantly human, for the other, through love, to the glory of God. For the church and the world to be transformed into the image of the God of cruciform love, we need leaders who are themselves intentionally engaging the church and the world in worship marked by cruciform love. Further, worship itself is a means by which this cruciform love is manifested. Without the embodied, enacted cruciform love of God, the world will not meet Jesus, the world will not be changed, and the world will continue to consider “church” an irrelevant vestige of a romanticized, defunct religion now relegated to the status of a historical society or tourist attraction.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But what if we could disciple generations of worship pastors and congregants to be cruciform leaders who disciple cruciform disciples, who minister to the church in ways that help to transform the people of God—through the cruciformational ministry of the gospel of love harmonized and melodized—into a renewal in the image of God’s love? What if worship pastors, who exercise a great degree of theological and spiritual influence over the church, would cease viewing themselves as artists (as opposed to theologians) but instead viewed themselves as artistic theologians? What would it look like if this ethos of cruciformity became the narrative spirituality and script of the life of the entire church? The world? This is already happening in many of our churches, and praise God! My prayer and hope is rooted in the continued cultivation and proliferation of a global, ecclesial culture of cruciform worship leading to cruciform, Christlike character among all of the congregants of the church. This "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page26",
      "title": "26"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _vm._v("must be the way forward. The church without the embodiment of the way of the cross and resurrection will never be a mechanism of transformation that ushers in the kingdom of God. Rather, it will be a museum, or worse, a mausoleum, for there is no place other than a tomb in which a religion can be placed (or disposed of) once its animating force has been removed in the name of civic unity and generic spirituality.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As we have observed in chapter one, contrary to the teachings of pop psychology and much contemporary American thought, we do not exist in this world as blank-slate individuals operating from an ahistorical, acultural place of autonomous reasoning and action. Instead, we are entangled in cultural stories, customs, rules, and social realities that precede us and that continue after we are gone; stories that shape us and stories through which we learn to become shapers of the world. But what kind of a world is shaping us, and what kind of a world are we, in turn, shaping?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Through reflecting on the social experience of a toddler in a park, it becomes apparent that the liturgies of the world are not of a singular variety but in fact coexist—often with great tension and friction—as an overlapping collage of incompatible ethical, religious, and political commitments developed and held, in many cases, at a precritical level of understanding. Sometimes these narratives overlap cohesively in commensurable ways. When this happens we can find common ground with our neighbors. More often than not, however, our narrative commitments clash. We can observe this in the various approaches and responses to violence, coercion, and justice from the stories discussed above. When friction does occur, it leaves us with at least two options. The first option is to ignore the differences in the name of a homogeneous and vacuous so-called unity. This unity seeks to pacify and placate the tension created by difference through encouraging a generic, lowest-common-denominator approach to truth and convictions. This neuters the ability of such truth or convictions to speak prophetically and powerfully in revolutionary ways that are able to transform individuals, communities, and the world. The alternative approach acknowledges the conflicting narratives and opts to live in the midst of the tension. And precisely through that good gospel tension, we experience cruciform tension, change, revolution, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page27",
      "title": "27"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  }), _vm._v("knowledge, and progress while injustices, lies, and false stories are brought clearly into focus and called to account.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The Christian is called to take the latter route, living into the tension created by the reconciling narrative of new creation in Christ Jesus. The question remains, however, what does any of this have to do with worship? Good question! In its fullest exposition, the inquiries raised in this chapter will have to wait until the following chapters to be fully explained. Suffice it to say here that the aim of this book is to highlight the way in which worship forms worshipers through love into the image of the God who is love. This transformational aspect to worship is not meant to operate at a merely individual level. Rather, like the communal experience of life in the park, worship that transforms us and renews us in the image of God is—through and through—a necessarily communal endeavor, guided by communal practices, truths, ethical precepts, and hopes that point to a communal eschatological goal—namely, the new heavens and the new earth. Within this community, worship leaders (and, really, all Christians) are charged with the gospel task of enacting the cruciform love of Christ to others and, conversely, receiving the cruciform love of Christ from others. When the church acts in this manner, we image and incarnate Jesus to one another in and through communal life and worship. The result of this is that we are transformed from one degree of glory to another by gazing at the glory of God in the face of Jesus Christ in one another ("), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=2+Cor+4%3A4-6",
      "target": "_blank"
    }
  }, [_vm._v("2 Cor 4:4-6")]), _vm._v("; see also 3:18).")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_vm._v("Conclusion: The Return of Peace to the Park of God’s New Creation")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Our cultures and our communities shape us and help us to become world shapers by providing us with sets of rules, patterns of behavior, and beliefs—as evidenced by my experiences at Encanto Park. It is also the case that the park can represent a sort of “preperfection of all things by Jesus” paradigm of how community and worship are meant to function. At the same park, on the same day that my son experienced his first potty humor name-calling session and that he was the victim of his first make-believe murder, Liam and I also experienced some truly beautiful and profound realities. We saw hundreds of happy children playing youth soccer "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page28",
      "title": "28"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  }), _vm._v("matches on the massive, open green grass fields of Encanto Park. On this beautiful, sunny, seventy-five-degree Arizona day, the smell of BBQ permeated the air, and a quick panoramic sweep of the park grounds revealed about fifty public cookouts taking place simultaneously, celebrating everything from birthdays to church group meetings to simple neighborhood gatherings. A scattering of individuals was dispersed randomly across the grassy areas bordering the sports fields, seated upon blankets, relaxing and reading books while enjoying the fresh air and the shared, open, natural space in the midst of an otherwise large, disparate, often isolated and lonely metropolitan city center. After absorbing all of the life around me, I reflected upon the energy, joy, clarity, and healing that I felt permeating my inmost being from this place and these people.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("It struck me as my son swayed to and fro on the swing set, kept in motion by my occasional push, that this gathering of culturally and ethnically diverse people, engaged in play with and enjoyment of each other and of the land and resources, was a perfect proleptic picture and paradigm of the new creation we read about in the book of Revelation, in which every nation, tribe, and tongue dwell together in the new earth, worshiping the Lamb and living in perfect harmony with God and one another. By "), _c('i', {
    staticClass: "i"
  }, [_vm._v("proleptic")]), _vm._v(" I refer to the present inbreaking and experience of a reality that is complete only in the future. Only by living proleptically, that is, living now by the sure hope of the future, can we bring into the present the reign, rule, and transformative presence of the kingdom of God. A key component to the experience of the proleptic presence of the kingdom of God is the community of Christ engaged in transformative, cruciform worship that yields the presence of God’s new-creation kingdom in the systems, structures, and individual lives of our communities and across the entire world.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As my time at the park was nearing an end, I noticed that while I was reflecting upon all of this dense theological stuff, a man dressed in traditional Jewish clothing and his son had come to use the swing directly next to Liam and me. The boy, a toddler around my son’s age, began to laugh. Liam, upon hearing the laughter, looked at the boy and began laughing as well, reciprocating and participating in his new neighbor’s joy. Both the boy’s father and I smiled as we observed our sons in the midst of such "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page29",
      "title": "29"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  }), _vm._v("simple contentment together. There was no hate, no violence, no coercion, and no pretend killing; there was only family, friendship, community, participation, and joy. After a few minutes the boy’s father addressed me, “If only life could be as innocent and simple for us as it is for these guys now! If they only knew . . .” I responded by saying; “Yeah! I know, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But inside of my mind and heart one thought and desire reverberated, albeit while remaining unspoken: "), _c('i', {
    staticClass: "i"
  }, [_vm._v("What if life really is meant to be that innocent and simple, but we’ve become so calloused, so confused, and so seduced and distracted by the narratives of this world that we’ve forgotten the simple truth of the one narrative that actually does matter, the gospel? "), _c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/Text/notes#_idTextAnchor896",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("2")])]), _vm._v(" "), _c('i', {
    staticClass: "i"
  }, [_vm._v("What if we remembered that the true story of what it means to be abundantly alive and human, the gospel, is not characterized by a retreat from, renunciation of, and graduation from simplicity, innocence, and everlasting peace, but rather it is driven by a power that seeks to retrieve and revive these things for the life of the world by the communal renovation of our hearts through the cruciformational worship of Jesus Christ?")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The kingdom of God is already here. Yet it is not fully present. The sin of the world still corrupts our experience of the proleptic inbreaking of the kingdom park of the new creation. However, the means to the proleptic presence of the new-creation park of the kingdom of God is not through walking in the way of passivity, acquiescence, or complacency in regard to the false narratives, rules, and patterns of this world. Rather, it is made present—enacted and received—through communal, worshipful walking in the way of the cross.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Through this cruciform existence as a worshiping community, the reconciled church becomes the means by which God reconciles the world to himself. When the reconciled become reconcilers, our communion with God and one another empowers us to refuse and contradict the world as it is and to see it transformed through the cruciform love of God—the one who created it and the one who is redeeming it."), _c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/notes#_idTextAnchor897",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("3")])]), _vm._v(" The way to redemption is always through the communal worship and embodiment of the crucified God, through whom we receive the power to exit the narrative of this world and to rewrite life.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page30",
      "title": "30"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page31",
      "title": "31"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3106701d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch2.vue
// module id = 75
// module chunks = 0